import { TServiceTicket } from "~/types";
import { baseService } from "../base";
import { PaginationResponse } from "../type";
import {
  CreateServiceTicketDto,
  GetServiceTicketParams,
  ImportServiceTicketsResponse,
  UpdateServiceTicketDto,
  CompleteServiceTicketDto,
} from "./service-ticket.types";

export const serviceTicketService = {
  createServiceTicket: async (payload: CreateServiceTicketDto) => {
    // Convert addOnServices to array of IDs if needed
    const addOnServices = payload.addOnServices?.map((item) =>
      typeof item === "string" ? item : item.id
    );

    const requestPayload = {
      ...payload,
      addOnServices,
    };

    console.log('Creating service ticket with payload:', JSON.stringify(requestPayload, null, 2));

    try {
      const { data } = await baseService.post("/service-tickets", requestPayload);
      console.log('Service ticket created successfully:', data);
      return data;
    } catch (error: any) {
      console.error('Error creating service ticket:', error);
      console.error('Error response data:', JSON.stringify(error.response?.data, null, 2));
      console.error('Error status:', error.response?.status);
      console.error('Error message from server:', error.response?.data?.message);
      console.error('Full error response:', error.response);
      throw error;
    }
  },
  updateServiceTicket: async ({ id, ...payload }: UpdateServiceTicketDto) => {
    // Convert addOnServices to array of IDs if needed
    const addOnServices = payload.addOnServices?.map((item) =>
      typeof item === "string" ? item : item.id
    );

    const requestPayload = {
      ...payload,
      addOnServices,
    };

    console.log('Updating service ticket with payload:', JSON.stringify(requestPayload, null, 2));

    try {
      const { data } = await baseService.patch(`/service-tickets/${id}`, requestPayload);
      console.log('Service ticket updated successfully:', data);
      return data;
    } catch (error: any) {
      console.error('Error updating service ticket:', error);
      console.error('Error response data:', JSON.stringify(error.response?.data, null, 2));
      console.error('Error status:', error.response?.status);
      console.error('Error message from server:', error.response?.data?.message);
      console.error('Full error response:', error.response);
      throw error;
    }
  },
  getServiceTickets: async (params?: GetServiceTicketParams) => {
    const { data } = await baseService.get<PaginationResponse<TServiceTicket>>(
      "/service-tickets",
      {
        params: params ?? {
          page: 1,
          pageSize: 50,
        },
      }
    );
    return data;
  },
  getServiceTicketsForDashboard: async (params?: GetServiceTicketParams) => {
    const { data } = await baseService.get<PaginationResponse<TServiceTicket>>(
      "/service-tickets/dashboard",
      {
        params: params ?? {
          page: 1,
          pageSize: 200,
        },
      }
    );
    return data;
  },
  getServiceTicket: async (id: string) => {
    const { data } = await baseService.get<TServiceTicket>(
      `/service-tickets/${id}`
    );
    return data;
  },
  getMyServiceTickets: async (params?: GetServiceTicketParams) => {
    const { data } = await baseService.get<PaginationResponse<TServiceTicket>>(
      "/service-tickets/my-service",
      {
        params,
      }
    );
    return data;
  },
  // completeServiceTicket: async (id: string) => {
  //   const { data } = await baseService.patch(`/service-tickets/${id}/complete`);
  //   return data;
  // },
  completeServiceTicket: async (payload: CompleteServiceTicketDto) => {
    const { data } = await baseService.patch(
      `/service-tickets/${payload.id}/complete`,
      payload
    );
    return data;
  },
  deleteServiceTicket: async (id: string) => {
    const { data } = await baseService.delete(`/service-tickets/${id}`);
    return data;
  },
  importServiceTickets: async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await baseService.post<ImportServiceTicketsResponse>(
      "/service-tickets/import",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  },
  getUpcomingServiceTicketsByInventoryId: async (inventoryId: string, params?: GetServiceTicketParams) => {
    const { data } = await baseService.get<PaginationResponse<TServiceTicket>>(
      `/service-tickets/by-inventory/${inventoryId}`,
      {
        params: params ?? {
          page: 1,
          pageSize: 10,
        },
      }
    );
    return data;
  },
  getHistoryServiceTicketsByInventoryId: async (inventoryId: string, params?: GetServiceTicketParams) => {
    const { data } = await baseService.get<PaginationResponse<TServiceTicket>>(
      `/service-tickets/history-by-inventory/${inventoryId}`,
      {
        params: params ?? {
          page: 1,
          pageSize: 10,
        },
      }
    );
    return data;
  },
  getServiceTicketInventories: async (id: string) => {
    const { data } = await baseService.get<TServiceTicket>(
      `/service-tickets/${id}/inventories`
    );
    return data;
  },
  calculateEstimate: async (input: {
    inventoryIds?: string[];
    templateItems?: { templateId: string; quantity: number }[];
    addOnServiceIds?: string[];
  }) => {
    const { data } = await baseService.post(
      `/service-tickets/calculate-estimate`,
      input
    );
    return data;
  },
};
